import React, { useEffect, useState } from 'react';
import { ChevronDown, HelpCircle } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import WhatsAppButton from '../components/WhatsAppButton';
import PageHero from '../components/PageHero';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(0);

  useEffect(() => {
    document.title = 'FAQ | Frequently Asked Questions | Digi Loans Bazaar';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', 'Answers to common questions about business loans, hospital project financing, medical equipment loans, and working capital from Digi Loans Bazaar Hyderabad.');
    }
    window.scrollTo(0, 0);
  }, []);

  const faqs = [
    {
      q: 'What types of loans does Digi Loans Bazaar offer?',
      a: 'We offer Business Loans, Hospital Project Financing, Medical Equipment Loans & Refinance, Doctor Loans, Working Capital, Overdraft, Personal Loans, and Home Loans. We specialize in unsecured business and healthcare financing.'
    },
    {
      q: 'How much loan amount can I get for a hospital project?',
      a: 'We provide Start-up Hospital Funding up to ₹10 Crore with up to 100% project financing. The actual amount depends on your project requirements, financial profile, and lender approval.'
    },
    {
      q: 'Do I need collateral for business loans?',
      a: 'No collateral is required for most of our unsecured business loans, MSME loans, and doctor loans. Collateral may be required for higher amounts or specific loan types based on lender policy.'
    },
    {
      q: 'What is the repayment tenure?',
      a: 'Repayment tenure flexibility goes up to 7 years for hospital project financing. Tenure for other loans varies from 1 to 7 years based on the loan type and lender.'
    },
    {
      q: 'How long does it take to get loan approval?',
      a: 'Quick approvals - typically within 7-15 working days after document submission. The exact timeline depends on the lender and completeness of documentation.'
    },
    {
      q: 'What documents are required?',
      a: 'KYC documents (Aadhaar, PAN), income proof (ITR, bank statements), business registration documents, project report (for hospital/business loans), and property documents if applicable.'
    },
    {
      q: 'Do you charge any fees for consultation?',
      a: 'Our initial consultation is FREE. We help you understand the best loan options for your needs. Processing fees, if any, are charged by the lending bank/NBFC as per their policy.'
    },
    {
      q: 'Can I finance medical equipment like MRI, CT Scan, X-Ray?',
      a: 'Yes! We provide dedicated Medical Equipment Loans and Refinance options for MRI, CT Scan, Ultrasound, X-Ray systems, Lab equipment, and other diagnostic machines.'
    },
    {
      q: 'What is included in Complete Hospital Setup Financing?',
      a: 'Medical equipment, hospital beds & furniture, woodwork & interiors, air conditioning, generators, glass work, modular OT & ICU setup, nursing stations, reception areas, and all other essential hospital infrastructure.'
    },
    {
      q: 'How do I apply for a loan?',
      a: 'Simply fill out our contact form, call us at +91 9703850009, or message us on WhatsApp. Our expert will get back to you within 24 hours with a customized financing solution.'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-32">
        <PageHero
          badge="Help Center"
          badgeIcon={HelpCircle}
          title="Frequently Asked"
          highlightWord="Questions"
          subtitle="Find answers to common questions about our loan services"
          breadcrumb="FAQ"
        />
        <div className="container mx-auto px-4 py-12">
          <div className="max-w-4xl mx-auto">

            <div className="space-y-4">
              {faqs.map((faq, index) => (
                <div
                  key={index}
                  className="bg-white border border-gray-200 rounded-xl overflow-hidden hover:shadow-lg transition-shadow"
                >
                  <button
                    onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                    className="w-full flex items-center justify-between p-6 text-left hover:bg-gray-50 transition-colors"
                  >
                    <span className="font-semibold text-gray-900 pr-4">{faq.q}</span>
                    <ChevronDown
                      className={`w-5 h-5 text-blue-600 flex-shrink-0 transition-transform duration-300 ${
                        openIndex === index ? 'rotate-180' : ''
                      }`}
                    />
                  </button>
                  {openIndex === index && (
                    <div className="px-6 pb-6 text-gray-700 leading-relaxed border-t border-gray-100 pt-4">
                      {faq.a}
                    </div>
                  )}
                </div>
              ))}
            </div>

            {/* CTA */}
            <div className="mt-12 bg-gradient-to-br from-blue-600 to-blue-700 rounded-2xl p-8 text-center text-white shadow-xl">
              <h2 className="text-2xl font-bold mb-3">Still have questions?</h2>
              <p className="text-blue-100 mb-6">Our loan experts are ready to help you</p>
              <div className="flex flex-col sm:flex-row gap-3 justify-center">
                <a
                  href="tel:+919703850009"
                  className="bg-white text-blue-700 font-semibold px-6 py-3 rounded-lg hover:bg-gray-100 transition-all hover:scale-105"
                >
                  📞 Call +91 9703850009
                </a>
                <a
                  href="mailto:prasad@digiloansbazaar.com"
                  className="bg-amber-500 text-white font-semibold px-6 py-3 rounded-lg hover:bg-amber-600 transition-all hover:scale-105"
                >
                  📧 Email Us
                </a>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default FAQ;
